export class SetZoom {
  static readonly type = '[Zoom] Set zoom';
  constructor(public payload: { zoom: number; min: number; max: number }) {
    if (this.payload.max === undefined) {
      this.payload.max = 100000;
    }
    if (this.payload.min === undefined) {
      this.payload.min = 0.0001;
    }
  }
}

export class ZoomIn {
  static readonly type = '[Zoom] Zoom in';
  constructor(public payload: { factor: number; limit: number }) {
    if (this.payload.limit === undefined) {
      this.payload.limit = 100000;
    }
  }
}

export class ZoomOut {
  static readonly type = '[Zoom] Zoom out';
  constructor(public payload: { factor: number; limit: number }) {
    if (this.payload.limit === undefined) {
      this.payload.limit = 0.0001;
    }
  }
}
